var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"overlay fixed w-100",on:{"click":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }